import jsonStringfy from 'fast-json-stable-stringify';

export function encodeObject<T>(obj: T): string {
	return btoa(jsonStringfy(obj));
}
